import * as RD from "src/types/remoteData";
import { BreadcrumbData } from ".";
import * as Url from "../url";

type Organization = { id: string; path: string };
export const getBreadcrumbsForHome = (
  organization: RD.RemoteData<unknown, Organization>
): BreadcrumbData[] => {
  return [
    organization.map((org) => ({
      label: "Organization",
      href: Url.OrgAdmin.Org.settings(org),
    })),
  ];
};

export const getBreadcrumbsForSettings = (
  organization: RD.RemoteData<unknown, Organization>
): BreadcrumbData[] => {
  return [
    ...getBreadcrumbsForHome(organization),
    organization.map((org) => ({
      label: "Settings",
      href: Url.OrgAdmin.Org.settings(org),
    })),
  ];
};

export const getBreadcrumbsForBoundaries = (
  organization: RD.RemoteData<unknown, Organization>
): BreadcrumbData[] => {
  return [
    ...getBreadcrumbsForHome(organization),
    organization.map((org) => ({
      label: "Boundaries",
      href: Url.OrgAdmin.Org.boundaries(org),
    })),
  ];
};

export const getBreadcrumbsForEditExplore = (
  organizationData: RD.RemoteData<unknown, Organization>,
  exploreId: string
): BreadcrumbData[] => {
  return [
    ...getBreadcrumbsForSettings(organizationData),
    organizationData.map((data) => ({
      label: `Edit ${exploreId}`,
      href: Url.OrgAdmin.Org.editExplore(data, exploreId),
    })),
  ];
};
